import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useCallback } from "react";
import { useMutation } from "react-relay";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import {
  ShareBookingInput,
  useShareBookingMutation,
} from "./__generated__/useShareBookingMutation.graphql";

export const useShareBooking = () => {
  const [shareBooking, isSharing] = useMutation<useShareBookingMutation>(
    useShareBookingMutationString
  );

  const { showToast } = useToast();

  const handleShareBooking = useCallback(
    ({
      input,
      onSuccessCallback,
    }: {
      input: ShareBookingInput;
      onSuccessCallback: (shareUrl: string) => void;
    }) => {
      shareBooking({
        variables: {
          input,
        },
        onCompleted: (res) => {
          // call callback and pass the share url back.
          if (
            res.shareBooking?.success &&
            res.shareBooking?.booking?.shareUrl
          ) {
            onSuccessCallback(res.shareBooking.booking.shareUrl);
          }
        },
        onError: () => {
          showToast({
            title: t`Well that's awkward...`,
            description: t`Something went wrong sharing this booking. Please try again.`,
            semanticStyle: "error",
            toastId: "share-booking-error",
          });
        },
      });
    },
    [shareBooking, showToast]
  );

  return { handleShareBooking, isSharing };
};

const useShareBookingMutationString = graphql`
  mutation useShareBookingMutation($input: ShareBookingInput!) {
    shareBooking(input: $input) {
      success
      booking {
        shareUrl
      }
    }
  }
`;
